import { useEffect, useState, useContext } from "react";
import { api } from "../App";
import Card from "./card";
import Loading from "./loading";

const KidsClasses = () => {
  const { apiData } = useContext(api);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    const kidsClasses = apiData.filter(
      (obj) =>
        obj.category_id === 359 && obj.tags?.some((obj) => obj.name === "kids")
    );
    setClasses(kidsClasses);
  }, [apiData]);

  useEffect(() => {
    if (classes.length) {
      setLoading(false);
    }
  }, [classes]);

  return loading ? (
    <Loading />
  ) : (
    <div className="api-data">
      {!!classes.length ? (
        classes.map((obj) => <Card obj={obj} key={obj.id} />)
      ) : (
        <p className="nothing">There is nothing coming up at this time.</p>
      )}
    </div>
  );
};

export default KidsClasses;
